import { AsyncAction } from '../../base-classes/asyncAction';
import { ColdFluProvider } from '../providers/coldFluProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_COLD_FLU_STORIES = new AsyncAction('GET_COLD_FLU_STORIES');

export function getColdFluStories(...params) {

    let paramsObject = {
        baseUrl: undefined,
        path: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        category: undefined,
        includeVideos: undefined,
        recordsLimit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_COLD_FLU_STORIES.base,
        payload: getColdFluStoriesAction(paramsObject)
    };
}

async function getColdFluStoriesAction({ baseUrl, path, authId, secret, stdParameters, verbose, category, includeVideos, recordsLimit}) {
    const op = new ColdFluProvider(baseUrl, authId, secret);
    return await op.getColdFluStories(stdParameters, path, verbose, category, includeVideos, recordsLimit);
}
